import { Component } from '@angular/core';
import {
  TopazBadgeModule,
  TopazBreadcrumbComponent, TopazCapsuleModule, TopazSearchModule, LoaderService, TopazFilterItem, TopazDialogMaxSize, TopazFilterModule, SingleFilterComponent
}
  from '@pearsonvue/topaz-angular-ui';
import { faCalendar, faEllipsisVertical, faCircleCheck, faXmark, faCalendarDays } from '@fortawesome/pro-regular-svg-icons';
import { take, map } from 'rxjs/operators';
import { SppdashboardService } from '../sppdashboard.service';
import { timer } from 'rxjs';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { MatDialog } from '@angular/material/dialog';
// import { DialogComponent } from '../dialog/dialog.component'
import { Router } from '@angular/router';


@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  standalone: false,
  styleUrl: './announcement.component.scss'
})
export class AnnouncementComponent {

  singleSelectData: any;
  filterSelected: any;
  selectedSingleFilterWithCategory: any;
  isLabelBold: boolean = false;
  asc: any;
  title: any;
  announcements: any;

  public currentPage: any = 0;
  length = 1;
  pageSize = 10;
  pageSizeOptions = [5, 10, 15, 25, 50, 100];
  showFirstLastButtons = true;
  showPageSizeOptions = true;
  totalElements: any = '0';
  last: boolean = false;
  public iconAriaLabel: string = 'Example home icon';

  constructor(private _dialog: MatDialog, private sppdashboardService: SppdashboardService, private loaderService: LoaderService, private router: Router
  ) { }
  icons = { faCalendar, faArrowUpRightFromSquare, faCalendarDays }
  public onSearch(e: string) {
    this.title = e;
    // Reset to first page when searching or clearing
    this.currentPage = 0;
    this.fetchAnnouncements();
  }

  public onClearSearch() {
    this.title = '';
    this.currentPage = 0;
    this.fetchAnnouncements();
  }

  ngOnInit() {
    this.singleSelectData = [...this.languages];
    this.singleSelectData.unshift({ name: 'Sort by', value: { id: null } });
    this.filterSelected = [{ name: 'Sort by', value: { id: null } }];
    this.fetchAnnouncements();
  }

  public fakeRequest(): void {
    timer(0, 500)
      .pipe(
        take(2),
        map((v) => v % 5 === 0)
      )
      .subscribe({
        next: (v) => {
          if (v) {
            this.loaderService.showLoader('Loading...');
          } else {
            this.loaderService.hideLoader();
          }
        }
      });
  }

  public loadMore() {
    this.fakeRequest();
    this.currentPage = this.currentPage + 1;
    this.fetchAnnouncements();
  }

  public fetchmoreAnnouncements() {
    this.sppdashboardService.getAnnouncements(this.title ? this.title : '', this.asc != undefined ? this.asc : true, this.currentPage, this.pageSize).subscribe((response: any) => {
      this.announcements = response.data.result.content.filter((item: any) => sessionStorage.getItem('status') === 'ALUMNI' ? item.announcementType === 'Alumni' : item.announcementType !== 'Alumni');
    }
    )
  }


  // public openSimpleDialog(anncmnt: any): void {
  //   if (anncmnt.new) {
  //     this.sppdashboardService.viewAnnouncement(anncmnt.announcementId).subscribe((response: any) => {
  //       if (response) {
  //         setTimeout(() => { this.fetchAnnouncements() }, 100);
  //       }
  //     })
  //   }
  //   const dialogRef = this._dialog.open(DialogComponent, {
  //     data: anncmnt,
  //     maxWidth: TopazDialogMaxSize.MEDIUM
  //   })

  //   dialogRef.afterClosed().subscribe((value) => {
  //     // Will log out "yes" or "no" based on the
  //     // mat-dialog-close attribute in the dialog template
  //     // console.log(value);
  //   })
  // }

  public viewancmt(anncmnt: any) {
    window.open(anncmnt.url, '_blank');
    if (anncmnt.new) {
      this.sppdashboardService.viewAnnouncement(anncmnt.announcementId).subscribe((response: any) => {
        if (response) {
          setTimeout(() => { this.fetchAnnouncements() }, 100);
        }
      })
    }
  }

  public fetchAnnouncements() {
    this.sppdashboardService.getAnnouncements(this.title ? this.title : '', this.asc != undefined ? this.asc : true, this.currentPage, this.pageSize).subscribe((response: any) => {
      this.announcements = response.data.result.content.filter((item: any) => sessionStorage.getItem('status') === 'ALUMNI' ? item.announcementType === 'Alumni' : item.announcementType !== 'Alumni');
      this.totalElements = response.data.result.totalElements;
      this.length = this.announcements.length;
      this.last = response.data.result.last;
      this.announcements.forEach((item: any) => {
        const date = new Date(item.dateOfEvent);
        const monthName = date.toLocaleString('en-US', { month: 'long' });
        const year = new Date(item.dateOfEvent).getFullYear();
        const dat = new Date(item.dateOfEvent).getDate();
        item.dateOfEvent = monthName + ' ' + dat + ', ' + year;
      })
    })
  }

  /**
     * This is the list of *all* possible filters
     */
  public languages: TopazFilterItem[] = [
    {
      name: 'Most recent',
      value: {
        id: 'en_US'
      }
    },
    {
      name: 'Oldest first',
      value: {
        id: 'fr_FR'
      }
    },
  ]

  /*
    this method handles the change in selection and handles if none is selected.
    If none is selected default selection is restored
    */
  public handleSingleFilterWithCategorySelectionChange(
    changed: TopazFilterItem[]
  ) {
    this.selectedSingleFilterWithCategory = changed;
    this.filterSelected[0].name = changed[0].name;

    if (changed[0].name == "Most recent") {
      this.asc = true;
    }
    else {
      this.asc = false;
    }

    this.fetchAnnouncements();

    if (changed[0].name !== 'Sort by') {
      this.isLabelBold = true;
    } else {
      this.isLabelBold = false;
    }
  }

  backto() {
    this.router.navigate(['/home']);
  }

}
